import React, { FunctionComponent, useCallback } from 'react'
import { TermLink } from '../../TermLink'
import { Text, useDesignLanguagePerClass, useIsDesignLanguage, DesignLanguage } from '@afterpaytouch/core'
import { useIsApplePaylater, useSelectedPaymentType } from '../../../state'
import { PaymentType } from '@afterpay/types'
import styles from './style.module.css'
import { TrackingEvent } from '../../../model/monitoring'
import { useMonitoringWithEnduringEventProperties } from '../../../integrations/monitoring'
import { Trans, useTranslation } from '../../../utils/convergence'
import { useCheckoutSizes } from '../../../utils/responsive'

export const PaymentTypesTerms: FunctionComponent = () => {
  const { t } = useTranslation()
  const selectedPaymentType = useSelectedPaymentType()
  const isApplePaylater = useIsApplePaylater()
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const { extraSmallTextSize } = useCheckoutSizes()
  const linkColor = isArcadeDesignLanguage ? 'Black' : 'Orca'
  const designLanguageStyles = useDesignLanguagePerClass(styles)
  const sendAnalyticsEvent = useCallback((): void => logEvent(TrackingEvent.PRESSED_CL_ENTRY_PAGE_DISCLAIMER_LINK), [logEvent])

  const components = {
    terms: (
      <TermLink
        key='payment-options-terms'
        fontFace='CashSansMono'
        href={t('consumerLending:termsOfServiceUrl')}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
        color={linkColor}
      />
    ),
    privacy: (
      <TermLink
        key='payment-options-privacy'
        fontFace='CashSansMono'
        href={t('common:privacyPolicyUrl')}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
        color={linkColor}
      />
    ),
    febPrivacy: (
      <TermLink
        key='payment-options-feb-privacy'
        fontFace='CashSansMono'
        href={t('consumerLending:febPrivacyPolicyUrl')}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
        color={linkColor}
      />
    ),
    creditReportAuthorization: (
      <TermLink
        key='payment-options-credit-report-authorization'
        fontFace='CashSansMono'
        href={t('consumerLending:creditReportAuthorizationUrl')}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
        color={linkColor}
      />
    ),
    consent: (
      <TermLink
        key='payment-options-consent'
        fontFace='CashSansMono'
        href={t('consumerLending:eSignConsentUrl')}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
        color={linkColor}
      />
    ),
    creditGuide: (
      <TermLink
        key='payment-options-credit-guide'
        fontFace='CashSansMono'
        href={t('consumerLending:creditGuide')}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
        color={linkColor}
      />
    ),
    creditReportingCollectionNotice: (
      <TermLink
        key='payment-options-credit-reporting-collection-notice'
        fontFace='CashSansMono'
        href={t('consumerLending:creditReportingCollectionNotice')}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
        color={linkColor}
      />
    ),
  }

  return selectedPaymentType === PaymentType.PCL ? (
    <div className={designLanguageStyles.termsWrapper} data-testid='payment-types-terms-wrapper'>
      <Text color='Gray40' size={isArcadeDesignLanguage ? 'XXS' : extraSmallTextSize} fontFace='CashSansMono'>
        <Trans
          i18nKey={isApplePaylater ? 'consumerLending:paymentOptions.termsApplePaylater' : 'consumerLending:paymentOptions.terms'}
          components={components}
        />
      </Text>
    </div>
  ) : null
}
